import _ from 'lodash';
import { evaluateDateRangeExpression, isValidDateRangeExpression } from '@skyjs/date';

export default getQueryExpression => ({
  getPathExpression: (path, value) => {
    if (!isValidDateRangeExpression(value, ['UTCDateRange'])) {
      throw new Error(`Invalid UTCDateRange value: ${value}`);
    }

    const expression = evaluateDateRangeExpression(value, ['UTCDateRange']);
    const criteria = _.isArray(expression)
      ? _.set(
          {},
          '$or',
          expression.map(e => ({ [path.join('.')]: e }))
        )
      : _.set({}, path.join('.'), expression);

    return getQueryExpression(criteria);
  }
});
